import { render, staticRenderFns } from "./featuresCard.vue?vue&type=template&id=7b0517f2&scoped=true"
import script from "./featuresCard.vue?vue&type=script&lang=js"
export * from "./featuresCard.vue?vue&type=script&lang=js"
import style0 from "./featuresCard.vue?vue&type=style&index=0&id=7b0517f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0517f2",
  null
  
)

export default component.exports